import { JwtTokenFn, LoginConfig, LoginOutFn } from "@me8eon/authentication";

export type TeamsApp = {
    app: {
        initialize: () => Promise<void>
        getContext: () => Promise<any>;
    }
}

export type TeamsAuthentication = {
    authentication: {
        getAuthToken: JwtTokenFn
    }
}

export type TeamsAppAndAuthentication = TeamsApp & TeamsAuthentication

let teamsSdk: TeamsAppAndAuthentication | null = null;

function loadTeamsSdk(): TeamsAppAndAuthentication {
    if (!teamsSdk)
        try {
            teamsSdk = require("@microsoft/teams-js") as TeamsAppAndAuthentication;
        } catch (e: any) {
            teamsSdk = {
                app: {
                    initialize: () => Promise.reject(new Error("Teams not running")),
                    getContext: () => Promise.reject(new Error("No Teams context outside Teams context")),
                },
                authentication: {
                    getAuthToken: () => Promise.reject(new Error("No Teams token outside Teams context")),
                },
            };
        }
    return teamsSdk!;
}


export const isInTeams = async (_sdk: TeamsApp = loadTeamsSdk()): Promise<boolean> => {
    try {
        if (window.self === window.top) {
            return false;
        }
        await _sdk.app.initialize();
        // Now actually ask it for context
        const ctx = await _sdk.app.getContext();

        // A real Teams context will always populate hostClientType
        return (
            typeof ctx.app?.host?.clientType === "string" &&
            ctx.app?.host?.clientType !== ""
        );
    } catch (e: any) {
        console.log("Not in Teams:", e);
        return false; // Initialization failed, not in Teams
    }
};

export const createTeamsLoginConfig = (_sdk: TeamsAuthentication = loadTeamsSdk()): LoginConfig => {
    const jwtToken = _sdk.authentication.getAuthToken;

    const login: LoginOutFn = async (debugLog) => {
        throw new Error("No login during teams");
    };

    const refreshLogin: LoginOutFn = async (debugLog) => {
        debugLog("Teams token refresh initiated");
        return jwtToken();
    };

    const logout: LoginOutFn = async (debugLog) => {
        throw new Error("No logout during teams");
    };

    const result: LoginConfig = {
        type: "teams",
        login,
        refreshLogin,
        logout,
        jwtToken,
    };
    return result;
};
